import classNames from "classnames";
import { ConditionalLink } from "components/conditionalLink";
import { useLeftBar } from "components/Sidebar/LeftBar";
import ConditionalToolTip from "components/design/conditionalToolTip";
import { ComponentType, ReactNode } from "react";

type SidebarStickyItemProps = {
  icon: ComponentType;
  label: string;
  to?: string;
  onClick?: () => void;
  suffix?: ReactNode;
};

export const SidebarStickyItem = ({
  icon: Icon,
  label,
  to,
  onClick,
  suffix,
}: SidebarStickyItemProps) => {
  const { open } = useLeftBar();

  const rowClass = classNames(
    "all:unset t-relative t-my-0.5 t-flex t-h-9 t-w-full t-cursor-pointer t-items-center t-gap-2 t-overflow-hidden t-rounded-md t-no-underline t-transition-all hover:t-bg-neutral-0",
    {
      "t-px-3": open,
      "t-justify-center t-px-0": !open,
    }
  );

  const content = (
    <>
      <span className="t-flex t-h-5 t-w-5 t-shrink-0 t-items-center t-justify-center t-text-text-30">
        <Icon />
      </span>
      {open && (
        <div className="t-flex t-min-w-0 t-flex-1 t-items-center t-justify-between t-gap-2">
          <span className="t-whitespace-nowrap t-text-body-sm t-text-text-60">
            {label}
          </span>
          {suffix}
        </div>
      )}
    </>
  );

  if (to) {
    return (
      <ConditionalToolTip condition={!open && label} side="right">
        <ConditionalLink to={to} onClick={onClick} className={rowClass}>
          {content}
        </ConditionalLink>
      </ConditionalToolTip>
    );
  }

  return (
    <ConditionalToolTip condition={!open && label} side="right">
      <button type="button" onClick={onClick} className={rowClass}>
        {content}
      </button>
    </ConditionalToolTip>
  );
};
